export default __webpack_public_path__ + "static/media/vscode-icons_file-type-firebase.7a12594d.svg";